import CutwiseAPIClient, { METHOD_DELETE, METHOD_POST, METHOD_PUT } from '@/common/network/CutwiseAPIClient';
import { CommentModel } from '@/product/entity/CommentModel';

export const PATH_COMMENT = 'api/comment';

enum CommentContextType {
  Collection = 'collection',
}

enum CommentObjectType {
  Product = 'product',
}

class CommentAPI {
  async createCollectionComment(collectionId: string, productId: number, text: string): Promise<CommentModel> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_POST).path(PATH_COMMENT).body({
      contextType: CommentContextType.Collection,
      contextId: collectionId,
      objectType: CommentObjectType.Product,
      objectId: productId,
      text,
    });

    const query = qb.getQuery();

    const res = await CutwiseAPIClient.sendQuery(query);

    return res.content;
  }

  async updateCollectionComment(collectionId: string, productId: number, text: string): Promise<CommentModel> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_PUT).path(PATH_COMMENT).body({
      contextType: CommentContextType.Collection,
      contextId: collectionId,
      objectType: CommentObjectType.Product,
      objectId: productId,
      text,
    });

    const query = qb.getQuery();

    const res = await CutwiseAPIClient.sendQuery(query);

    return res.content;
  }

  delete(commentId: string) {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_DELETE).path(`${PATH_COMMENT}/${commentId}`);

    const query = qb.getQuery();

    return CutwiseAPIClient.sendQuery(query);
  }
}

export default CommentAPI;
